import { FlexContainer, Spinner } from "../../design";
import React, { useEffect, useState } from "react";
import InvoiceDetails from "./components/InvoiceDetails";
import InvoiceLineItem from "./components/invoicelineitem";
import Notes from "./components/notes";
import DownLoadInvoice from "./components/downloadinvoice";
import { Col, Hidden, Row } from "react-awesome-styled-grid";
import { downloadInvoiceByInvoicePdfKey, getInvoiceLinkById, } from "../../api";
import InvoiceHeader from "./components/smallscreen/header/InvoiceHeader";
import InvoiceFooter from "./components/smallscreen/footer/InvoiceFooter";
import InvoiceLineItemMobile from "./components/smallscreen/invoicelineitemMobile/InvoiceLineItemMobile";

type Props = {
  history: {
    push: Function,
  },
}

const InvoiceLink = (props: Props) => {

  const [invoice, setInvoice] = useState(null);
  const [account, setAccount] = useState(null);
  const [support, setSupport] = useState(null);
  const [partialPaymentDetails, setPartialPaymentDetails] = useState(null);
  const [isShowSpinner, setShowSpinner] = useState(false);

  const { match: { params: { invoiceLinkId } }, location: { pathname } } = props;

  useEffect(() => {
    getInvoiceLinkDataWithoutSearchValue();
  }, [invoiceLinkId]);

  const getInvoiceLinkDataWithoutSearchValue = async () => {
    setShowSpinner(true);
    try {
      const value = await getInvoiceLinkById(invoiceLinkId, null);
      if (value) {
        setInvoice(value.invoice);
        setAccount(value.account);
        setSupport(value.account && value.account.support);
        if (value.invoice?.invoiceType === "PARTIAL") {
          const invoiceTermsAndConditions = value.invoice?.invoiceTermsAndConditions;
          setPartialPaymentDetails({
            initialAmount: invoiceTermsAndConditions?.initialAmount,
            pendingAmount: invoiceTermsAndConditions?.pendingAmount,
            dueDate: value.invoice?.paymentDueDate,
            lateFee: invoiceTermsAndConditions?.lateFee,
            overdueInterest: invoiceTermsAndConditions?.overdueInterest,
          });
        }
      }
    } catch (e) {
      props.history.push(`${pathname}/error`)
    } finally {
      setShowSpinner(false)
    }
  };

  const download = async () => {
    if (invoice && invoice.invoicePdfKey) {
      setShowSpinner(true);
      try {
        const value = await downloadInvoiceByInvoicePdfKey(invoice.invoicePdfKey);
        if (value) {
          const { fileUrl } = value;
          if (fileUrl) {
            window.location = fileUrl;
          }
        }
      } finally {
        setShowSpinner(false);
      }
    }
  };

  return (
    <>
      <FlexContainer
        flexDirection="column"
        className="w-100 px-1 px-md-2 px-lg-5"
        justify-content="center"
        display="block"
      >
        <Row>
          <Col xs={4} sm={8} md={5} lg={8} xl={7} className="align-items-center px-0">
            <Col xs={4} sm={8} md={7} lg={8} xl={8} className="px-3 px-lg-0 w-100">
              <InvoiceHeader 
                invoice={invoice} 
                download={download} 
                history={props.history} 
                partialPaymentDetails={partialPaymentDetails}
                account={account}
              />
              <FlexContainer
                display="block"
                borderRadius="3px"
                boxShadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                className="text-center p-3 px-lg-5 mx-1 my-3 my-md-4 my-lg-5 bg-white"
              >
                <div className="mt-4">
                  <InvoiceDetails invoice={invoice} account={account} />
                  <InvoiceLineItemMobile
                    invoices={invoice && invoice.invoiceLineItems}
                    currency={invoice && invoice.currency}
                    invoice={invoice && invoice}
                  />
                  <Hidden sm xs>
                    <InvoiceLineItem
                      invoices={invoice && invoice.invoiceLineItems}
                      currency={invoice && invoice.currency}
                      invoice={invoice && invoice}
                    />
                  </Hidden>
                  <Notes invoice={invoice} account={account} />
                </div>
              </FlexContainer>
              <InvoiceFooter support={support} whiteLabel={account && account.whiteLabel} />
            </Col>
          </Col>
          <Hidden sm xs>
            <Col xs={4} md={3} lg={4} xl={5} className="align-items-center">
              <DownLoadInvoice
                account={account}
                phone={support && support.phone}
                email={support && support.email}
                download={download} history={props.history}
                status={invoice && invoice.status}
                partialPaymentDetails={partialPaymentDetails}
                currency={invoice && invoice.currency}
              />
            </Col>
          </Hidden>
        </Row>
      </FlexContainer>
      <Spinner isOpen={isShowSpinner} />
    </>
  )
};

export default InvoiceLink
